import React from 'react';
import './style.css';

const InfoBanner = ({ t }) => (
  <div className='info-banner'>
    <div className='info-banner__icon'>i</div>
    <div className='info-banner__content'>
      <p>{t('macactivation.info_banner_compatibility')}</p>
      <p>{t('macactivation.info_banner_deprecation')}</p>
      <div className='info-banner__download-title'>
        {t('macactivation.info_banner_download_title')}
      </div>
      <div className='info-banner__buttons'>
        <a
          className='info-banner__store-btn'
          href='https://apps.apple.com/us/app/chargepoint-installer/id1613254700'
          target='_blank'
          rel='noopener noreferrer'
        >
          {t('macactivation.info_banner_appstore')}
        </a>
        <a
          className='info-banner__store-btn'
          href='https://play.google.com/store/apps/details?id=com.chargepoint.ServicePro'
          target='_blank'
          rel='noopener noreferrer'
        >
          {t('macactivation.info_banner_googleplay')}
        </a>
      </div>
    </div>
  </div>
);

export default InfoBanner;
